module.exports = __webpack_public_path__ + "img/schedule_m1.0998b72e.png";